import { FormContainer } from 'react-hook-form-mui';
import { AvailableNumbersRequest } from '../../../sic-lib/api/twilio/types/AvailableNumbersRequest';
import { AvailableNumberFormControls } from './AvailableNumberFormControls';

type Props = {};

export function AvailableNumbersForm({}: Props) {
    //const { classes } = useStyles();

    return (
        <FormContainer<AvailableNumbersRequest>
            mode="all"
            defaultValues={{
                country: 'US',
            }}
        >
            <AvailableNumberFormControls />
        </FormContainer>
    );
}

//const useStyles = makeStyles()((theme: Theme) => ({}));
